<template>
  <div class="user-manage">
    <el-row class="white">
      <el-col :offset="1" :span="23">      <el-form ref="form" :inline="true" :model="boatInfo">
        <el-form-item label="船只名称" prop="boatName">
          <el-input v-model="boatInfo.boatName" placeholder="请输入船只名称"/>
        </el-form-item>
        <el-form-item label="船种名称" prop="kindId">
          <el-select v-model="boatInfo.kindId">
            <el-option v-for="item in boatKind"
            :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运营状态" prop="operateStatus">
          <el-select v-model="boatInfo.operateStatus">
            <el-option value="all" label="全部"></el-option>
            <el-option value="use" label="使用中"></el-option>
            <el-option value="free" label="空闲"></el-option>
            <el-option value="destroy" label="损坏"></el-option>
            <el-option value="lose" label="缺失"></el-option>
            <el-option value="service" label="维护"></el-option>
            <el-option value="stop" label="停用"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="码头名称" prop="wharfId">
          <el-select v-model="boatInfo.wharfId">
            <el-option v-for="item in wharf"
            :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button @click="handleReset('form')">重置</el-button>
        </el-form-item>
      </el-form>
      </el-col>
    </el-row>
    <div class="base-table">
      <div class="action">
        <el-button type="primary" @click="handleCreate">新增</el-button>
        <!-- <el-button type="primary" @click="handleCreate">导出</el-button> -->
        <el-button @click="handleAllot" type="primary">调拨</el-button>
      </div>
      <el-table
        :cell-style="cellStyle"
        :data="boatList">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          v-for="item in columns"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :formatter="item.formatter">
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="290px">
          <template #default="scope">
            <el-button @click="handleEdit(scope.row)" type="primary" size="mini">修改</el-button>
            <el-button @click="handleEnable(scope.row)"  v-if="scope.row.operateStatus == 'stop'" type="primary" size="mini">启用</el-button>
              <el-button @click="handleStop(scope.row)" v-else type="primary" size="mini">停用</el-button>
            <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="pageShow"
        class="pagination"
        background
        layout="total,prev,pager,next"
        :total="pager.total"
        :page-size="10"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- <base-table
    :columns="columns"
    :data="boatList"
    :pager="pager"
    :cell-style="cellStyle"
    @handleAction="handleAction"
    @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:action>
      <el-button type="primary" @click="handleCreate">新增</el-button>
      </template>
    </base-table> -->
    <el-dialog :title="dialogTitle" v-model="showModal" @close="handleClose">
      <el-form ref="dialogForm" :model="boatForm" label-width="120px" :rules="rules">
        <el-form-item label="船种名称" prop="kindId">
          <el-select v-model="boatForm.kindId" :disabled="action === 'edit'" @change="selectChange(currentVessel, boatForm.kindId)">
            <el-option v-for="item in boatKindNoneAll"
            :key="item._id" :label="item.kindName" :value="item._id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="ships-statement" label="船只编号" prop="SelfBoatSn">
          <el-input disabled class="vessel-number" v-model="currentVessel.firstVessel" placeholder="请选择船种以获取船只编号"/>
          <el-input v-model="boatForm.SelfBoatSn" placeholder="请输入船只编号后四位数字"/>
        </el-form-item>
        <el-form-item label="船只名称" prop="boatName">
          <el-input v-model="boatForm.boatName" placeholder="请输入船种名称"/>
        </el-form-item>
        <el-form-item label="使用年限(年)" prop="durableYears">
          <!-- <el-input v-model.number="boatForm.durableYears" placeholder="请输入使用年限"/> -->
          <el-input-number v-model.number="boatForm.durableYears" :min="1" />
        </el-form-item>
        <el-form-item label="码头名称" prop="wharfId">
          <el-select v-model="boatForm.wharfId" :disabled="action == 'edit'">
            <el-option v-for="item in wharfNoneAll"
            :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="核载人数" prop="number">
          <el-input-number v-model.number="boatForm.number" :min="1" />
        </el-form-item> -->
        <el-form-item label="运营状态" prop="operateStatus"  v-if="action == 'edit'">
          <el-select v-model="boatForm.operateStatus" disabled>
            <el-option value="use" label="使用中"></el-option>
            <el-option value="free" label="空闲"></el-option>
            <el-option value="destroy" label="损坏"></el-option>
            <el-option value="lose" label="缺失"></el-option>
            <el-option value="service" label="维护"></el-option>
            <el-option value="stop" label="停用"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="handleSubmit">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 调拨 -->
    <el-dialog title="调拨" v-model="showAllotModal" @close="handleAllotClose">
      <el-form ref="dialogAllotForm" :model="allotForm" label-width="120px" :rules="allotRules">
         <el-form-item label="船种名称" prop="kindId">
          <el-select v-model="allotForm.kindId" @change="selectChange(currentAllotVessel, allotForm.kindId)">
            <el-option v-for="item in boatKindNoneAll"
            :key="item._id" :label="item.kindName" :value="item._id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="源码头" prop="sourceWharfId">
          <el-select v-model="allotForm.sourceWharfId">
            <el-option v-for="item in wharfNoneAll"
            :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标码头" prop="aimWharfId">
          <el-select v-model="allotForm.aimWharfId">
            <el-option v-for="item in wharfNoneAll"
            :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="ships-statement" label="开始船只编号" prop="startBoatSn">
          <el-input disabled class="vessel-number" v-model="currentAllotVessel.firstVessel" placeholder="请选择船种以获取船只编号"/>
          <el-input v-model="allotForm.startBoatSn" placeholder="请输入开始船只编号"/>
        </el-form-item>
        <el-form-item class="ships-statement" label="结束船只编号" prop="endBoatSn">
          <el-input disabled class="vessel-number" v-model="currentAllotVessel.firstVessel" placeholder="请选择船种以获取船只编号"/>
          <el-input v-model="allotForm.endBoatSn" placeholder="请输入结束船只编号"/>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" :rows="2" v-model="allotForm.description" placeholder="请输入描述"/>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleAllotClose">取 消</el-button>
          <el-button type="primary" @click="handleAllotSubmit">调 拨</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, reactive, ref, toRaw } from 'vue'
import utils from '../../utils/utils'
export default {
  name: 'BoatInfoManager',
  setup () {
    // 获取Composition API 上下文对象
    const { proxy } = getCurrentInstance()
    const form = [
      // {
      //   type: 'input',
      //   label: '船只名称',
      //   model: 'boatName',
      //   placeholder: '请输入船只名称'
      // },
      // {
      //   type: 'select',
      //   label: '船种',
      //   model: 'kindName',
      //   placeholder: '请选择船种',
      //   options: boatKindOptions
      // },
      // {
      //   type: 'date',
      //   label: '添加时间',
      //   model: 'createTime',
      //   placeholder: '请输入添加时间'
      // }
    ]
    // 初始化表单对象
    const boatInfo = ref({

    })
    // 初始化列表对象
    const boatList = ref([]);
    // 初始化船种对象
    const boatKind = ref([]);
    // 初始化船种对象(无全部)
    const boatKindNoneAll = ref([]);
    // 初始化码头对象
    const wharf = ref([]);
    // 初始化码头对象（无全部）
    const wharfNoneAll = ref([]);
    // 初始化分页对象
    const pager = reactive({
      pageNum: 1,
      pageSize: 10
    })
    // 是否展示分页
    const pageShow = ref(true);
    // 弹框显示对象
    const showModal = ref(false);
    // 调拨弹框对象
    const showAllotModal = ref(false);
    // 新增Form对象
    const boatForm = reactive({
      durableYears: 1,
      number: 1,
    })
    // 调拨Form对象
    const allotForm = reactive({})
    // 弹框的标题
    const dialogTitle = ref('')
    // 弹框的操作
    const action = ref('add');
    // 船只编号
    const currentVessel = reactive({
      firstVessel: '',
      lastVessel: ''
    });
    // 调拨船只编号
    const currentAllotVessel = reactive({
      firstVessel: '',
      startVessel: '',
      endVessel: '',
    });
    const allotRules = reactive({
      kindId: [
        {
          required: true,
          message: '请选择船种',
          trigger: 'blur'
        }
      ],
      sourceWharfId: [
        {
          required: true,
          message: '请选择源码头',
          trigger: 'blur'
        }
      ],
      aimWharfId: [
        {
          required: true,
          message: '请选择目标码头',
          trigger: 'blur'
        }
      ],
      startBoatSn: [
        {
          required: true,
          message: '请输入开始船只编号',
          trigger: 'blur'
        }
      ],
      endBoatSn: [
        {
          required: true,
          message: '请输入结束船只编号',
          trigger: 'blur'
        }
      ]
    })
    // 定义表单校验规则
    const rules = reactive({
      SelfBoatSn: [
        {
          required: true,
          message: '请输入船只编号后四位数字',
          trigger: 'blur'
        }
      ],
      boatName: [
        {
          required: true,
          message: '请输入船只名称',
          trigger: 'blur'
        }
      ],
      durableYears: [
        {
          required: true,
          message: '请输入使用年限',
          trigger: 'blur'
        },
        {
          type: 'number',
          message: '使用年限必须是数字',
          trigger: 'blur'
        }
      ],
      kindId: [
        {
          required: true,
          message: '请选择船种',
          trigger: 'blur'
        }
      ],
      wharfId: [
        {
          required: true,
          message: '请选择码头',
          trigger: 'blur'
        }
      ]
    })
    // 定义动态表格-格式
    const columns = reactive([
      // {
      //   type: 'selection'
      // },
      {
        label: '船只编号',
        prop: 'boatSn',
        width: '150px'
      },
      {
        label: '船只名称',
        prop: 'boatName'
      },
      {
        label: '船种名称',
        prop: 'kindName'
      },
      {
        label: '码头名称',
        prop: 'wharfName'
      },
      {
        label: '运营状态',
        prop: 'operateStatus',
        formatter (row, column, value) {
          if (value === 'use') {
            return '使用中'
          } else if (value === 'free') {
            return '空闲'
          } else if (value === 'destroy') {
            return '损坏'
          } else if (value === 'lose') {
            return '缺失'
          } else if (value === 'service') {
            return '维护'
          } else if (value === 'stop') {
            return '停用'
          }
        }
      },
      {
        label: '启用时间(年)',
        prop: 'useDate',
        formatter (row, column, value) {
          return utils.formateDate(value)
        }
      },
      {
        label: '使用年限',
        prop: 'durableYears'
      },
      {
        label: '核载人数(位)',
        prop: 'number'
      }
      // {
      //   type: 'action',
      //   label: '操作',
      //   width: '300',
      //   list: [
      //     {
      //       type: 'primary',
      //       text: '修改',
      //       visible: true
      //     },
      //     {
      //       type: 'primary',
      //       text: '启用',
      //       visible: true
      //     },
      //     {
      //       type: 'primary',
      //       text: '停用',
      //       visible: true
      //     },
      //     {
      //       type: 'primary',
      //       text: '调拨',
      //       visible: true
      //     },
      //     {
      //       type: 'danger',
      //       text: '删除',
      //       visible: true
      //     }
      //   ]
      // }
    ])
    // 初始化接口调用
    onMounted(() => {
      getBoatInfoList()
      getBoatKindDic()
      getWharfDic()
      getBoatKindList()
      // getWharfList();
    })
    // 获取船种类型
    const getBoatKindDic = async () => {
      const params = {}
      try {
        const res = await proxy.$api.getBoatKindDic(params);
        boatKind.value = res
        // console.log(boatKind.value)
      } catch (error) {
        console.log(error)
      }
    };
    // 获取船种类型(无全部)
    const getBoatKindList = async () => {
      const params = {}
      try {
        const res = await proxy.$api.getBoatKindList(params);
        boatKindNoneAll.value = res
        // console.log(boatKind.value)
      } catch (error) {
        console.log(error)
      }
    };
    // 新增船只编号开头填充
    const selectChange = async (target, value) => {
      target.firstVessel = boatKind.value.find(v => v.key === value).kindSn;
    };
    // 获取码头类型
    const getWharfDic = async () => {
      const params = {}
      try {
        const res = await proxy.$api.getWharfDic(params)
        wharf.value = res
        const result = JSON.parse(JSON.stringify(res))
        result.shift();
        wharfNoneAll.value = result;
        // console.log(boatKind.value)
      } catch (error) {
        console.log(error)
      }
    }
    // 获取船只列表
    const getBoatInfoList = async (values) => {
      const params = utils.pageService(pager, values);
      try {
        const res = await proxy.$api.getBoatInfoList(params)
        boatList.value = res.data
        pager.total = res.totalNum
      } catch (error) {
        console.log(error)
      }
    }
    // 查询事件， 获取船只列表
    const handleQuery = () => {
      const values = boatInfo.value
      const newValues = utils.checkParmas(values)
      pager.pageNum = 1
      pageShow.value = false
      getBoatInfoList(newValues)
      proxy.$nextTick(() => {
        pageShow.value = true
      })
    }
    // 重置查询表单
    const handleReset = (form) => {
      proxy.$refs[form].resetFields()
      // getBoatInfoList()
    }
    // 分页事件处理
    const handleCurrentChange = (current) => {
      const values = boatInfo.value
      const newValues = utils.checkParmas(values)
      pager.pageNum = current
      getBoatInfoList(newValues)
    }
    // 启用
    const handleEnable = async (row) => {
      proxy.$confirm('是否确定启用?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await proxy.$api.enableBoat({ _id: row._id })
        proxy.$message({
          type: 'success',
          message: '已启用!'
        })
        getBoatInfoList()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    }
    // 停用
    const handleStop = async (row) => {
      proxy.$confirm('是否确定停用?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await proxy.$api.unenableBoat({ _id: row._id })
        proxy.$message({
          type: 'success',
          message: '已停用!'
        })
        getBoatInfoList()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    }
    // 单个删除
    const handleDel = async (row) => {
      proxy.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const data = await proxy.$api.delBoatInfo({ _id: row._id });
        if(data){
          proxy.$message({
            type: 'success',
            message: '删除成功!'
          });
          getBoatInfoList();
        };
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
    // 新增表单
    const handleCreate = () => {
      currentVessel.firstVessel = '';
      action.value = 'add';
      dialogTitle.value = '新增';
      showModal.value = true;
    }
    const handleAllot = () => {
      currentAllotVessel.firstVessel = '';
      showAllotModal.value = true
    }
    // 编辑表单
    const handleEdit = (row) => {
      action.value = 'edit'
      dialogTitle.value = '设置';
      showModal.value = true;
      currentVessel.firstVessel = row.kindSn;
      proxy.$nextTick(() => {
        boatForm._id = row._id
        boatForm.SelfBoatSn = row.boatSn.replace(row.kindSn, '')
        boatForm.boatName = row.boatName
        boatForm.kindId = row.kindId
        boatForm.wharfId = row.wharfId
        boatForm.durableYears = row.durableYears
        boatForm.number = row.number
        boatForm.operateStatus = row.operateStatus
      })
    }
    // 弹框关闭
    const handleClose = () => {
      showModal.value = false
      handleReset('dialogForm')
    }
    const handleAllotClose = () => {
      showAllotModal.value = false
      handleReset('dialogAllotForm')
    }
    // 处理按钮
    const handleAction = (values) => {
      if (values.index === 0) {
        handleEdit(values.row);
      } else if (values.index === 1) {
        handleDel(values.row)
      }
    }
    // 表格特殊行的样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (row.column.label === '运营状态' && (row.row.operateStatus === 'stop' ||
      row.row.operateStatus === 'service' ||
      row.row.operateStatus === 'lose' ||
      row.row.operateStatus === 'destroy'
      )) {
        return 'color:red'
      } else if (row.column.label === '运营状态' && (row.row.operateStatus === 'free' ||
      row.row.operateStatus === 'use')) {
        return 'color:#66c18c'
      }
    };
    // 调拨提交
    const handleAllotSubmit = () => {
      proxy.$refs.dialogAllotForm.validate(async (valid) => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(toRaw(allotForm)));
          params.startBoatSn = currentAllotVessel.firstVessel + params.startBoatSn;
          params.endBoatSn = currentAllotVessel.firstVessel + params.endBoatSn;
          params.operateType = 'allot';
          const res = await proxy.$api.allotBoat(params)
          if (res) {
            showAllotModal.value = false
            proxy.$message.success('调拨成功')
            handleReset('dialogAllotForm')
            getBoatInfoList()
          }
        }
      })
    }
    // 弹框提交
    const handleSubmit = () => {
      proxy.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          const userAction = action.value;
          if (userAction === 'add') {
            const params = toRaw(boatForm)
            if (params._id) {
              delete params._id
            };
            params.durableYears = parseInt(params.durableYears)
            params.number = parseInt(params.number);
            params.boatSn = currentVessel.firstVessel + params.SelfBoatSn;
            const res = await proxy.$api.addBoatInfo(params);
            if (res) {
              showModal.value = false
              proxy.$message.success('船只创建成功')
              handleReset('dialogForm')
              getBoatInfoList()
            };
          } else {
            const params = toRaw(boatForm)
            params.durableYears = parseInt(params.durableYears)
            params.number = parseInt(params.number);
            params.boatSn = currentVessel.firstVessel + params.SelfBoatSn;
            const res = await proxy.$api.editBoatInfo(params)
            if (res) {
              showModal.value = false
              proxy.$message.success('船只编辑成功')
              handleReset('dialogForm')
              getBoatInfoList()
            }
          }
        }
      })
    }
    return {
      form,
      boatKind,
      boatKindNoneAll,
      boatInfo,
      wharfNoneAll,
      getBoatKindDic,
      boatList,
      columns,
      getBoatInfoList,
      pager,
      handleQuery,
      handleReset,
      handleCurrentChange,
      handleDel,
      handleCreate,
      showModal,
      showAllotModal,
      boatForm,
      rules,
      handleClose,
      handleSubmit,
      action,
      handleAction,
      handleEdit,
      dialogTitle,
      cellStyle,
      wharf,
      selectChange,
      handleAllot,
      allotForm,
      handleAllotClose,
      handleAllotSubmit,
      allotRules,
      pageShow,
      handleEnable,
      handleStop,
      currentVessel,
      currentAllotVessel,
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ships-statement){
  display: flex;
  .el-form-item__content{
    display: flex;
    .vessel-number{
      width: 23%;
    }
  }
}
</style>
